import { render, staticRenderFns } from "./PageSnapshot.vue?vue&type=template&id=718a53c7&scoped=true&"
import script from "./PageSnapshot.vue?vue&type=script&lang=js&"
export * from "./PageSnapshot.vue?vue&type=script&lang=js&"
import style0 from "../../styles/content-page.css?vue&type=style&index=0&id=718a53c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718a53c7",
  null
  
)

export default component.exports